import React, { useEffect, useState } from "react";
import ChangelogModal from "./ChangelogModal";

const ChangelogModalWrapper = (props) => {
  const [changelog, setChangelog] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // อ่านไฟล์ CHANGELOG.md จาก public folder
    // ในโหมด development: http://localhost:3000/CHANGELOG.md
    // ในโหมด production: https://yourserver.com/CHANGELOG.md
    const changelogUrl = process.env.PUBLIC_URL + "/CHANGELOG.md";
    console.log("Loading changelog from:", changelogUrl);

    fetch(changelogUrl)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.text();
      })
      .then((text) => {
        console.log(
          "✅ Changelog loaded successfully:",
          text.substring(0, 200) + "..."
        );
        setChangelog(text);
        setLoading(false);
      })
      .catch((error) => {
        console.error("❌ Error loading CHANGELOG.md:", error);
        console.log("📝 Using fallback changelog data");
        // ใช้ข้อมูล fallback ถ้าไม่สามารถโหลดไฟล์ได้
        setChangelog("");
        setLoading(false);
      });
  }, []);

  if (loading) {
    console.log("⏳ Loading changelog...");
  }

  return (
    <ChangelogModal
      open={props.open}
      onClose={props.onClose}
      changelog={changelog}
    />
  );
};

export default ChangelogModalWrapper;
